<form [formGroup]="searchForm" (keyup.enter)="searchOrganization()" autocomplete="off">
    <ul class="search__criteria">
        <li>
            <label class="mvd_label--inline">
                <input type="checkbox" formControlName="exactSearch" /> Exact Match
            </label>
        </li>
        <li>
            <label class="mvd_label--inline disabled">
                <input type="checkbox" disabled /> Extended
            </label>
        </li>
    </ul>
    <p-panel #toggleablePanel [toggleable]="true" [collapsed]="!showSearchCriteria" (onAfterToggle)="showSearchCriteria = !$event.collapsed">
        <p-header>
            Search Criteria
        </p-header>
        <fieldset>
            <div class="row">
                <div class="col-sm-5 col-md-4 col-lg-3 mvd_form-group">
                    <label>ID Type</label>
                    <select id="customerIdentificationTypeInput" class="mvd_form-control" formControlName="customerIdentificationTypeId">
                        <option [ngValue]="null">- Select -</option>
                        <option *ngFor="let identificationType of customerIdentificationTypes" [ngValue]="identificationType.id">{{ identificationType.displayValue }}</option>
                    </select>
                    <div class="alert alert-required" *ngIf="searchForm.dirty && searchForm.hasError('idTypeRequired')">Customer ID Type is required</div>
                </div>
                <div class="col-sm-5 col-md-4 col-lg-3 mvd_form-group">
                    <label class="required--multi" title="~ At least one is required" for="customerIdentificationValueInput">
                        {{ customerIdentificationType() }}
                    </label>
                    <input id="customerIdentificationValueInput" class="mvd_form-control" type="text" #customerIdentificationValue formControlName="customerIdentificationValue" trim="blur" />
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="searchForm.get('customerIdentificationValue').hasError('maxlength')">
                            {{ customerIdentificationType() }} has a maximum length of {{ searchForm.get('customerIdentificationValue').errors.maxlength.requiredLength}} characters
                        </div>
                        <div class="mvd_alert__rule" *ngIf="(searchForm.get('organizationName').touched || searchForm.get('customerIdentificationValue').touched) && searchForm.hasError('organizationNameOrIdNumberRequired')">
                            {{ customerIdentificationType() }} or Organization Name is required
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="mvd_form-group col-sm-10 col-md-8 col-lg-6">
                    <label class="required--multi" title="~ At least one is required" for="organizationName">Organization Name</label>
                    <input id="organizationName" class="mvd_form-control" type="text" formControlName="organizationName" trim="blur" />
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="searchForm.get('organizationName')?.hasError('maxlength')">
                            Organization name has a maximum length of {{ searchForm.get('organizationName')?.errors['maxlength'].requiredLength }} characters
                        </div>
                        <div class="mvd_alert__rule" *ngIf="(searchForm.get('customerIdentificationValue')?.touched || searchForm.get('organizationName')?.touched) && searchForm.hasError('organizationNameOrIdNumberRequired')">
                            {{ customerIdentificationType() }} or Organization Name is required
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="mvd_form-group col-sm-2">
                    <label for="zipcodeInput">ZIP Code</label>
                    <input id="zipcodeInput" class="mvd_form-control" type="text" formControlName="postalZipCode" trim="blur" />
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="searchForm.get('postalZipCode')?.hasError('maxlength')">
                            ZIP Code has a maximum length of {{ searchForm.get('postalZipCode')?.errors['maxlength'].requiredLength }} characters
                        </div>
                    </div>
                </div>
                <div class="mvd_form-group col-sm-4">
                    <label for="cityInput">City</label>
                    <input id="cityInput" class="mvd_form-control" formControlName="city" trim="blur" />
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="searchForm.get('city')?.hasError('maxlength')">
                            City has a maximum length of {{ searchForm.get('city')?.errors['maxlength'].requiredLength }} characters
                        </div>
                    </div>
                </div>
                <div class="mvd_form-group col-sm-3">
                    <label for="stateInput">State</label>
                    <select id="stateInput" class="mvd_form-control" formControlName="jurisdictionId">
                        <option [ngValue]="null"></option>
                        <option *ngFor="let state of states" [ngValue]="state.id">{{ state.displayValue }}</option>
                    </select>
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="searchForm.hasError('stateRequired')">State is required</div>
                    </div>
                </div>
                <div class="mvd_form-group col-sm-2">
                    <label for="countyInput">County</label>
                    <select id="countyInput" class="mvd_form-control" formControlName="countyId">
                        <option [ngValue]="null"></option>
                        <option *ngFor="let county of counties" [ngValue]="county.id">{{ county.displayValue }}</option>
                    </select>
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="searchForm.hasError('countyWrongState')">
                            County is only allowed when State is AZ
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="mvd_form-group col-sm-3">
                    <label for="phoneNumberInput">Phone Number</label>
                    <input id="phoneNumberInput" class="mvd_form-control" type="text" placeholder="xxx xxx-xxxx" formControlName="phoneNumber" trim="blur" />
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="searchForm.get('phoneNumber')?.hasError('maxlength')">
                            Phone Number has a maximum length of {{ searchForm.get('phoneNumber')?.errors['maxlength']?.requiredLength }} characters
                        </div>
                    </div>
                </div>
                <div class="mvd_form-group col-sm-3">
                    <label for="emailAddressInput">Email Address</label>
                    <input id="emailAddressInput" class="mvd_form-control" type="text" formControlName="emailAddress" trim="blur" />
                    <div class="mvd_alert__validation">
                        <div class="mvd_alert__rule" *ngIf="searchForm.get('emailAddress')?.hasError('maxlength')">
                            Email Address has a maximum length of {{ searchForm.get('emailAddress')?.errors['maxlength']?.requiredLength }} characters
                        </div>
                    </div>
                </div>
            </div>
        </fieldset>
        <div class="well__footer">
            <div class="btn--group" *ngIf="searchForm.dirty">
                <button class="btn--default" type="button" (click)="reset()">Reset</button>
                <mvm-spinner-btn id="organizationCustomerSearchFind" [isDisabled]="!searchForm.valid" [isLoading]="showButtonLoading" btnText="Find" (clicked)="searchOrganization()"></mvm-spinner-btn>
            </div>
        </div>
    </p-panel>
</form>
<div class="well__footer mvd_form-group" *ngIf="showResults || validationMessage != ''">
	<h2 class="mvd_alert--label">{{ validationMessage }}</h2>
	<a class="icon--add" href="javascript:void(0)" (click)="addNewCustomer()" ifSecurityTransaction='["AddCustomer"]'> Add New Customer</a>
</div>